import { useCallback, useEffect, useState } from 'react'
import type { ChangeEvent } from 'react'

export function usePropertyOptionalBundleSelection(rateId: string) {
  const [selectedBundleId, setSelectedBundleId] = useState<string>()

  // Switching rate re-renders this component tree rather than remounting it, so the previous rate's
  // selection would otherwise stick around against bundles that no longer exist.
  useEffect(() => {
    setSelectedBundleId(undefined)
  }, [rateId])

  const onToggleBundle = useCallback((bundleId: string, event: ChangeEvent<HTMLInputElement>) => {
    const checked = event.currentTarget.checked
    setSelectedBundleId(previousSelectedBundleId => {
      if (checked) return bundleId
      return previousSelectedBundleId === bundleId ? undefined : previousSelectedBundleId
    })
  }, [])

  return {
    selectedBundleId,
    onToggleBundle,
  }
}

export default usePropertyOptionalBundleSelection
